import { ConstantsParser } from '../../../ConstantsParser'
import { StylesParser } from '../../../StylesParser'

export class Primary {
	constructor() {
		this.name = 'Primary'
		this.content = {
			text: 'Primary',
      hasPrefix: false,
      hasSuffix: false,
      hasTitle: false,
      prefix: '+',
      suffix: '%',
      counter: 100,
      interval: 50
		}
		this.view = this.viewHtml()
	}

	viewHtml() {
		let classes = (new ConstantsParser(this.classes())).parse().join(' ')
		let styles = (new StylesParser(this.styles())).parse()
		styles = Object.keys(styles).map(variationStyle => `${variationStyle}:${styles[variationStyle]}`).join(';')

		return `<div
				class="${classes}"
				style="${styles}"
			>primary</div>`
	}

	classes() {
		return []
	}

	styles() {
		return []
	}

  containerClasses() {
    return [
      { property: 'PaddingTop', value: 'PADDING_TOP_XS'},
      { property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
      { property: 'PaddingLeft', value: 'PADDING_LEFT_XXS'},
      { property: 'PaddingRight', value: 'PADDING_RIGHT_XXS'},
    ]
  }

  containerStyles() {
    return [
      { property: 'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #f56565, #f56565)'},
    ]
  }

  counterClasses() {
    return [
      { property: 'FontWeight', value: 'NORMAL'},
      { property: 'FontSize', value: 'FONT_SIZE_3XL'},
    ]
  }

  counterStyles() {
    return [
      { property: 'TextColor', styleProperty: 'color', value: '#ffffff' }
    ]
  }

  titleClasses() {
    return [
      { property: 'FontWeight', value: 'NORMAL'},
      { property: 'FontSize', value: 'FONT_SIZE_BASE'},
    ]
  }

  titleStyles() {
    return [
      { property: 'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

	buildData() {
		return {
			name: this.name,
			view: this.view,
		}
	}

	editorProperties() {
		return {
			content: this.content,
			styles: {
				phone: this.styles(),
				tablet: this.styles(),
				desktop: this.styles(),
			},
			classes: {
				phone: this.classes(),
				tablet: this.classes(),
				desktop: this.classes(),
			},
      titleClasses: {
        phone: this.titleClasses(),
        tablet: this.titleClasses(),
        desktop: this.titleClasses(),
      },
      titleStyles: {
        phone: this.titleStyles(),
        tablet: this.titleStyles(),
        desktop: this.titleStyles(),
      },
      containerClasses: {
        phone: this.containerClasses(),
        tablet: this.containerClasses(),
        desktop: this.containerClasses(),
      },
      containerStyles: {
        phone: this.containerStyles(),
        tablet: this.containerStyles(),
        desktop: this.containerStyles(),
      },
      counterClasses: {
        phone: this.counterClasses(),
        tablet: this.counterClasses(),
        desktop: this.counterClasses(),
      },
      counterStyles: {
        phone: this.counterStyles(),
        tablet: this.counterStyles(),
        desktop: this.counterStyles(),
      }
		}
	}
}
